/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
    active-text-color="#ffd04b">
    <div class="logobox">
      <div>买单云-中台</div>
      <!-- <img class="logoimg" src="../assets/img/logo.png" alt=""> -->
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.keyName">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.title}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.children" :index="chmenu.path" :key="chmenu.id">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.title}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
  import {
    menu
  } from '../api/userMG'
  export default {
    name: 'leftnav',
    data() {
      return {
        collapsed: false,
        allmenu: []
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
			let pro = {
			  
			    "userId": JSON.parse(localStorage.getItem('userdata')).muId
			}
			console.log(pro)
      menu(pro).then(res => {
        console.log(res)
          if (res.code == 0) {
            this.allmenu = res.data
          } else {
            this.$message.error(res.message)
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            return false
          }
        })
        .catch(err => {
          // this.$message.error('菜单加载失败，请稍后再试！')

        })
      // 监听
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #1f2d3d !important;
  }

  .el-menu {
    border: none;
  }

  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
  }

  .logoimg {
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue